import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'orderBy',
    standalone: false
})
export class OrderByPipe implements PipeTransform {
  transform(array: Array<any>, orderField: string, orderType: boolean): Array<string> {
    array.sort((a: any, b: any) => {
      const ae = a[orderField];
      const be = b[orderField];
      if (!ae && !be) {
        return 0;
      }
      if (!ae && be) {
        return orderType ? 1 : -1;
      }
      if (ae && !be) {
        return orderType ? -1 : 1;
      }
      if (ae === be) {
        return 0;
      }

      if (Number(ae) && Number(be)) {
        return orderType ? (ae > be ? -1 : 1) : be > ae ? -1 : 1;
      }

      return orderType
        ? ae.toString().toLowerCase() > be.toString().toLowerCase()
          ? -1
          : 1
        : be.toString().toLowerCase() > ae.toString().toLowerCase()
          ? -1
          : 1;
    });
    return array;
  }
}
